import React from 'react';
import loadable from '@loadable/component';
import LoadingPage from '../LoadingPage';
import BrandsPage from '../Brands/BrandsPage';
import StandardPage from '../StandardPage/StandardPage';

const LoadableStandardCategoryPage = loadable(
  () => import('./StandardCategoryPage'),
  {
    fallback: LoadingPage,
  }
);

const CategoryPage = (props) => {
  if (props.category && props.category.id === 883) {
    return <StandardPage {...props} />;
  }
  if (props.category && props.category.id === 240) {
    return <BrandsPage {...props} />;
  }
  if (props.category && props.category.id === 328) {
    return <BrandsPage {...props} />;
  }
  if (
    props.category &&
    props.category.parent &&
    props.category.parent.id === 437
  ) {
    return <StandardPage {...props} />;
  }
  if (
    props.category &&
    props.category.parent &&
    props.category.parent.id === 372
  ) {
    return <StandardPage {...props} />;
  }

  return <LoadableStandardCategoryPage {...props} />;
};

export default CategoryPage;
